import { FUNC_DEFAULT } from 'constants';
import {
  PII_PROFILE_PERSONAL_DETAILS_FISTNAME_NAME,
  PII_PROFILE_PERSONAL_DETAILS_LASTNAME_NAME,
  PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_NAME,
  PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_POST_CODE_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_NAME,
} from 'features/pii/const';
import useProfile from 'features/profile2.0/hooks/useProfile';
import useProfileAPI from 'features/profile2.0/hooks/useProfileAPI';
import { address } from 'helpers';
import useAuth from 'hooks/useAuth';
import useCommonStore from 'hooks/useCommonStore';
import { isEmpty } from 'lodash';
import useProfileKYC from './useProfileKYC';

const useProfileKYCAPI = () => {
  const { token } = useAuth();
  const { currentUser, setCurrentUser } = useCommonStore();
  const { checkResidentialAddressProfileFullAddressChange } = useProfileKYC();
  const { saveProfileInformationRequest } = useProfileAPI();
  const { getProfileFullAddress } = useProfile();
  const { address: addressStore } = currentUser || {};
  const {
    fullAddress: fullAddressStore,
    street: streetStore,
    suburb: suburbStore,
    state: stateStore,
    postcode: postcodeStore,
    manual: manualStore,
  } = addressStore || {};

  const profileFullAddress = getProfileFullAddress();

  const getProfileKYCInformationPayloadTransform = ({
    profileInformation,
    documentUploadResponses,
  }) => {
    const isResidentialAddressProfileFullAddressInformationChange =
      checkResidentialAddressProfileFullAddressChange(
        profileInformation?.[PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME],
        profileFullAddress
      );

    const isEnterAddressManual = Boolean(
      profileInformation?.[PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_NAME]
    );
    const fullAddress =
      profileInformation?.[PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME];
    const addressStreet =
      address.addressStreetSplitFromFullAddress(fullAddress);
    const addressPostcode =
      address.addressPostcodeSplitFromFullAddress(fullAddress) || '';
    const postcode =
      profileInformation?.[PII_PROFILE_RESIDENTIAL_ADDRESS_POST_CODE_NAME] ||
      addressPostcode?.postcode ||
      postcodeStore ||
      '';
    const state =
      profileInformation?.[PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_NAME] ||
      addressPostcode?.state ||
      stateStore ||
      '';
    const suburb =
      profileInformation?.[PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_NAME] ||
      addressPostcode?.suburb ||
      suburbStore ||
      '';

    const firstName =
      profileInformation?.[PII_PROFILE_PERSONAL_DETAILS_FISTNAME_NAME];
    const lastName =
      profileInformation?.[PII_PROFILE_PERSONAL_DETAILS_LASTNAME_NAME];
    const occupation =
      profileInformation?.[PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_NAME];
    const prevOccupation =
      profileInformation?.[PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_NAME];

    let payload = {
      address: {
        fullAddress,
        manual: isEnterAddressManual,
        postcode,
        state,
        street: addressStreet,
        suburb,
      },
      docs: documentUploadResponses || [],
      firstName,
      lastName,
      occupation: {
        job: occupation?.key,
        previousJob: prevOccupation?.key || '',
      },
    };

    if (!isResidentialAddressProfileFullAddressInformationChange) {
      payload = {
        ...payload,
        address: {
          fullAddress: fullAddressStore,
          manual: manualStore,
          postcode: postcodeStore,
          state: stateStore,
          street: streetStore,
          suburb: suburbStore,
        },
      };
    }

    return payload;
  };
  const saveProfileKYCInformationRequest = async ({
    profileInformation = {},
    documentUploadResponses = [],
    errorCallback = FUNC_DEFAULT,
  }) => {
    const profileInformationPayload = getProfileKYCInformationPayloadTransform({
      profileInformation,
      documentUploadResponses,
    });
    console.log(
      `⭐ useProfileKYCAPI 👉 saveProfileKYCInformationRequest ➡️ profileInformationPayload ↩`,
      profileInformationPayload
    );
    let { data } = await saveProfileInformationRequest(
      token,
      profileInformationPayload,
      errorCallback
    );
    if (!isEmpty(data)) {
      setCurrentUser({
        token,
        ...currentUser,
        address: data?.address,
        docs: data?.docs,
        firstName: data?.firstName,
        lastName: data?.lastName,
        occupation: data?.occupation,
      });
      return { data };
    }
    return null;
  };

  return { saveProfileKYCInformationRequest };
};

export default useProfileKYCAPI;
